import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate
} from "react-router-dom";
import historyIcon from "../../assets/icons/historyIcon.svg";
import greaterThanIcon from "../../assets/icons/Next.svg";
import { LogoutCard } from "../../components/Cards/Cards";
import ConnectABDM from "../../components/ConnectABDM/ConnectABDM";
import PersonalDataConsentForm from "../../components/PersonalDataConsentForm/PersonalDataConsentForm";
import LogoutModal from "../../components/profile/LogoutModal";
import {
  AddIcon,
  ArrowIcon,
  ContinueIcon,
  SettingIcon,
  TickIcon
} from "../../front-end-global-components/assets/assets";
import ninto_logo from "../../front-end-global-components/assets/nintoLogo.svg";
import Button from "../../front-end-global-components/components/Button/Button";
import ConditionalRender from "../../front-end-global-components/components/ConditionalRender/ConditionalRender";
import FeatureFlagsFallback from "../../front-end-global-components/components/FeatureFlagsFallback/FeatureFlagsFallback";
import Header from "../../front-end-global-components/components/Header/Header";
import Modal from "../../front-end-global-components/components/Modal/Modal";
import RoundedProfilePicture from "../../front-end-global-components/components/RoundedProfilePicture/RoundedProfilePicture";
import useNavigationScenarios from "../../hooks/useNavigationScenarios";
import {
  clearClinicSearchResults,
  searchAbdmClinic,
  setSearchHistory
} from "../../redux/abdm/actions";
import { logout } from "../../redux/authentication/actions";
import {
  healthLockerAuthorization,
  setAuthModes,
  setConsentToPersonalData,
  setTransactionId,
  switchPatientProfile
} from "../../redux/patients/actions";
import { isValidArray, isValidObject } from "../../utils/validators";
import ABDMCreate from "../Abdm/ABDMCreate";
import ABDMList from "../Abdm/ABDMList";
import ABDMVerify from "../Abdm/ABDMVerify";
import ViewRequest from "../Abdm/ViewRequest/ViewRequest";
import ViewSearchedClinicCareContext from "../Abdm/ViewSearchedClinicCareContext";
import Incidents from "../Incidents/Incidents";
import ViewDocument from "../ViewDocument/ViewDocument";
import "./Home.css";
import Timeline from "./Timeline";
import UploadDocument from "./UploadDocument";
import ReArrangeFiles from "../../components/ReArrangeFiles/ReArrangeFiles";

function Home(props) {
  const [searchClinic, setSearchClinic] = useState("");
  const [file, setFile] = useState({ type: "", src: "" });
  const [src, setSrc] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  const [showFileNameModal, setShowFileNameModal] = useState(false);

  const searchResultElementRef = useRef(null);
  const documentUploadRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  const [hasValidAccessToken, setHasValidAccessToken] = useState(false);

  const isAbdmLoggedIn =
    props.auth.data?.abdmToken ||
    (isValidObject(props.patients.accessToken) &&
    Object.values(props.patients.accessToken).find(
      (p) => typeof p?.token === "string"
    )
      ? true
      : false);

  console.log(isAbdmLoggedIn, "isAbdmLoggedIn");

  // Check access token validity
  useEffect(() => {
    const { currentProfile, accessToken } = props.patients;
    if (
      typeof currentProfile === "string" &&
      isValidObject(accessToken) &&
      typeof accessToken?.[currentProfile]?.token === "string"
    ) {
      setHasValidAccessToken(true);
    } else {
      setHasValidAccessToken(false);
    }
    // eslint-disable-next-line
  }, [props.patients?.currentProfile, props.patients?.accessToken]);

  const getNotificationCounts = (profileId) => {
    if (!profileId || typeof profileId !== "string") {
      return 0;
    }

    const notifications = props.notifications?.data?.[profileId];
    if (!isValidObject(notifications)) {
      return 0;
    }

    return Object.values(notifications).filter((n) => !n.read).length;
  };

  const getHealthLockerSubscriptionRemainingDays = () => {
    if (!props.isSubscriptionValid?.subscription?.sources?.[0].period?.to) {
      return 0;
    }

    const expireDate = new Date(
      props.isSubscriptionValid.subscription.sources?.[0].period.to
    ).getTime();

    if (!expireDate) {
      return 0;
    }

    return Math.max(
      Math.round((expireDate - Date.now()) / (1000 * 60 * 60 * 24)),
      0
    );
  };

  const onNewDocumentCreate = (documentType) => {
    const fileTypeActions = {
      symptom: () => navigate("/symptom"),
      vital: () => {
        setFile((prev) => ({ ...prev, type: "vital" }));
        documentUploadRef.current?.click();
      },
      report: () => {
        setFile((prev) => ({ ...prev, type: "report" }));
        documentUploadRef.current?.click();
      },
      prescription: () => {
        setFile((prev) => ({ ...prev, type: "prescription" }));
        documentUploadRef.current?.click();
      },
      receipt: () => {
        setFile((prev) => ({ ...prev, type: "receipt" }));
        documentUploadRef.current?.click();
      },
      admission: () => {
        setFile((prev) => ({ ...prev, type: "admission" }));
        documentUploadRef.current?.click();
      },
      insurance: () => {
        setFile((prev) => ({ ...prev, type: "insurance" }));
        documentUploadRef.current?.click();
      },
      vaccine: () => {
        setFile((prev) => ({ ...prev, type: "vaccine" }));
        documentUploadRef.current?.click();
      },
      consultation: () => {
        setFile((prev) => ({ ...prev, type: "consultation" }));
        documentUploadRef.current?.click();
      },
      invoice: () => {
        setFile((prev) => ({ ...prev, type: "invoice" }));
        documentUploadRef.current?.click();
      },
      others: () => {
        setFile((prev) => ({ ...prev, type: "others" }));
        documentUploadRef.current?.click();
      }
    };

    const action = fileTypeActions[documentType];
    if (action) {
      action();
    }
  };

  const documentUploadTitle = (fileType) => {
    const titles = {
      reports: "Add Report",
      prescriptions: "Add Prescription",
      admissions: "Add Admission",
      receipts: "Add Receipt",
      insurances: "Add Insurance",
      vaccine: "Add Vaccine"
    };
    return titles[fileType] || "Add Document";
  };

  // Effects
  useEffect(() => {
    const searchResults = props.abdm?.clinics?.search?.results;
    if (
      isValidObject(searchResults) &&
      Object.keys(searchResults).length > 0 &&
      !location.pathname.includes("/clinicSearch")
    ) {
      clearClinicSearchResults();
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    const { currentProfile, accessToken } = props.patients;
    if (
      location.pathname === "/switchProfile" &&
      typeof accessToken?.[currentProfile]?.token === "string" &&
      currentProfile
    ) {
      navigate("/", { replace: true });
    }
    // eslint-disable-next-line
  }, [props.patients.currentProfile, props.patients?.accessToken]);

  const debugWhen = (id, conditions) => {
    const result = Object.values(conditions).every(Boolean);
    console.log(`[nav:when] ${id}`, conditions, "→", result);
    return result;
  };

  const navigationScenarios = ({
    hasValidAccessToken,
    src,
    pdfs,
    profiles,
    currentProfile,
    autoApprovalPolicies,
    linkingToken,
    subscription,
    patientsLoading,
    authorization,
    consentManagement,
    abdmToken,
    isSubscriptionValid
  }) => [
    {
      id: "featureFallback",
      when: (pathname) =>
        debugWhen("featureFallback", {
          notFallbackPath: !pathname.includes("/feature-flags-fallback"),
          noAuthorizationOrConsent: !authorization || !consentManagement
        }),
      target: "/feature-flags-fallback",
      log: "Navigating → /feature-flags-fallback"
    },
    {
      id: "switchProfile",
      when: (pathname) =>
        debugWhen("switchProfile", {
          notAbdmPath: !pathname.includes("/abdm"),
          notSwitchProfilePath: !pathname.includes("/switchProfile"),
          hasAbdmToken: !!abdmToken,
          noCurrentProfile: !currentProfile,
          hasProfiles: isValidObject(profiles)
        }),
      target: "/switchProfile",
      options: { replace: true },
      log: "Navigating → /switchProfile"
    },
    {
      id: "userConsent",
      when: (pathname) =>
        debugWhen("userConsent", {
          notSwitchProfilePath: !pathname.includes("/switchProfile"),
          notConsentPath: !pathname.includes("/locker/consent"),
          hasValidAccessToken,
          noConsentGiven:
            !profiles?.[currentProfile]?.consentToPersonalData?.userAgreed
        }),
      target: "/locker/consent",
      log: "Navigating → /locker/consent"
    },
    {
      id: "connectToAbdm",
      when: (pathname) =>
        debugWhen("connectToAbdm", {
          notSwitchProfilePath: !pathname.includes("/switchProfile"),
          notAbdmPath: !pathname.includes("/abdm"),
          notConnectPath: !pathname.includes("/connect"),
          notLogoutPath: !pathname.includes("/logout"),
          noValidAccessToken: !hasValidAccessToken,
          autoApprovalPoliciesLoaded: autoApprovalPolicies !== null,
          linkingTokenLoaded: linkingToken !== null,
          subscriptionLoaded: subscription !== null,
          profilesLoaded: profiles !== null,
          notLoading: !patientsLoading
        }),
      target: "/connect",
      log: "Navigating → /connect"
    },
    {
      id: "locker",
      when: (pathname) =>
        debugWhen("locker", {
          notAbdmPath: !pathname.includes("/abdm"),
          notClinicSearchPath: !pathname.includes("/clinicSearch"),
          notConsentPath: !pathname.includes("/locker/consent"),
          notSwitchProfilePath: !pathname.includes("/switchProfile"),
          notSubscribePath: !pathname.includes("/locker/subscribe"),
          hasValidAccessToken,
          noValidSubscription: !isValidObject(isSubscriptionValid)
        }),
      target: "/locker/subscribe",
      log: "Navigating → /locker/subscribe"
    },
    {
      id: "rearrangeImages",
      when: (pathname) =>
        debugWhen("rearrangeImages", {
          notRearrangePath: !pathname.includes("/rearrange"),
          hasSrcFiles: isValidArray(src) || isValidArray(pdfs)
        }),
      target: "/rearrange",
      log: "Navigating → /rearrange"
    },
    {
      id: "default",
      when: (pathname) =>
        debugWhen("default", {
          notConnectPath: !pathname.includes("/connect"),
          notAbdmPath: !pathname.includes("/abdm"),
          notClinicSearchPath: !pathname.includes("/clinicSearch"),
          notSwitchProfilePath: !pathname.includes("/switchProfile"),
          notTimelinePath: !pathname.includes("/patientTimeline"),
          noSrcFiles: !isValidArray(src),
          noPdfFiles: !isValidArray(pdfs),
          hasAbdmToken: !!abdmToken,
          hasCurrentProfile: !!currentProfile,
          consentGiven:
            !!profiles?.[currentProfile]?.consentToPersonalData?.userAgreed,
          hasValidSubscription: isValidObject(isSubscriptionValid)
        }),
      target: "/patientTimeline",
      log: "Navigating → /patientTimeline (default)"
    }
  ];

  const navState = {
    hasValidAccessToken,
    src,
    pdfs,
    profiles: props.patients?.profiles,
    currentProfile: props.patients?.currentProfile,
    autoApprovalPolicies: props.patients?.autoApprovalPolicies,
    linkingToken: props.patients?.linkingToken,
    subscription: props.patients?.subscription,
    patientsLoading: props.patients?.loading,
    authorization: props.app?.featureFlags?.authorization,
    consentManagement: props.app?.featureFlags?.consentManagement,
    abdmToken: isAbdmLoggedIn,
    isSubscriptionValid: props.isSubscriptionValid
  };
  // console.log("[nav] state:", navState);

  useNavigationScenarios({
    scenarios: navigationScenarios(navState),
    enableLogs: false
  });

  // Render subscription warning
  const SubscriptionWarning = () => {
    if (
      !isValidObject(props.isSubscriptionValid) ||
      !location.pathname.includes("/patientTimeline")
    ) {
      return null;
    }

    const remainingDays = getHealthLockerSubscriptionRemainingDays();
    if (remainingDays > 14) {
      return null;
    }

    return (
      <div
        className="margin-top-medium margin-bottom-medium margin-left-large margin-right-large padding-medium border-1px-e5e5e5 border-radius-default display-flex flex-justify-content-space-between flex-align-items-center"
        onClick={props.resubscribeClick}
      >
        <div>
          <div className="font-family-gilroy-medium">
            Ninto subscription will expire in{" "}
            {remainingDays === 0
              ? "day"
              : remainingDays === 1
              ? "1 day"
              : `${remainingDays} days`}
          </div>
          <div className="padding-top-small font-size-small">
            Access the features associated with ABDM
          </div>
        </div>
        <div>
          <ContinueIcon />
        </div>
      </div>
    );
  };

  const [localSearchOn, setLocalSearchOn] = useState(false);

  useEffect(() => {
    if (
      typeof props.searchKeyword === "string" &&
      props.searchKeyword.length > 0
    ) {
      setLocalSearchOn(true);
    } else {
      setLocalSearchOn(false);
    }
  }, [props.searchKeyword]);

  useEffect(() => {
    if (location.pathname.includes("/clinicSearch")) {
      setLocalSearchOn(true);
    } else {
      setLocalSearchOn(false);
    }
  }, [location]);

  const handleSearchToggle = (toggle) => {
    if (toggle) {
      navigate("/clinicSearch");
    } else {
      navigate("/");
    }
  };

  // Main render
  return (
    <div
      className="inherit-parent-height overflow-hidden"
      data-cy={
        isValidObject(props.patients?.profiles)
          ? `profiles-${Object.keys(props.patients.profiles).length}`
          : "no-profiles"
      }
    >
      <UploadDocument
        loading={props.documents?.loading}
        file={file}
        setFile={setFile}
        src={src}
        setSrc={setSrc}
        pdfs={pdfs}
        setPdfs={setPdfs}
        documentUploadRef={documentUploadRef}
        setShow={setShowFileNameModal}
        show={showFileNameModal}
      />

      <Routes>
        {/* Main Routes */}
        <Route
          path="/switchProfile"
          element={
            <>
              <Header
                displayName={
                  props.patients?.profiles?.[props.patients?.currentProfile]
                    ?.fullName
                }
                title={documentUploadTitle(file.type)}
                loading={false}
                searchKeyword={searchClinic}
                searchPlaceHolder="Search clinic / lab"
                profile-picture-data-cy="CURRENT-PROFILE-IMAGE"
                primary={!isValidArray(src) && !isValidArray(pdfs)}
                onProfilePictureClick={() =>
                  navigate(
                    isAbdmLoggedIn ? "/switchProfile" : "/logout/confirm"
                  )
                }
                userProfilePictureSrc={
                  props.patients?.healthIdData?.[props.patients?.currentProfile]
                    ?.profilePhoto
                    ? `data:image/png;base64, ${
                        props.patients.healthIdData[
                          props.patients?.currentProfile
                        ].profilePhoto
                      }`
                    : null
                }
                notificationsCount={getNotificationCounts(
                  props.patients?.currentProfile
                )}
                hideSupport={true}
                showQr={hasValidAccessToken}
                onQrClick={() => {
                  navigate("/settings/abdmHealthIdQr");
                }}
                backButtonOnClick={() => {
                  if (isValidArray(src) || isValidArray(pdfs)) {
                    setSrc([]);
                    setPdfs([]);
                  } else {
                    navigate(-1);
                  }
                }}
                onSearchUser={(clinicNameSearchKey) => {
                  if (
                    clinicNameSearchKey &&
                    clinicNameSearchKey !== searchClinic &&
                    hasValidAccessToken &&
                    !props.abdm?.loading
                  ) {
                    if (props.app?.featureFlags?.findClinic) {
                      setSearchClinic(clinicNameSearchKey);
                      searchAbdmClinic?.(clinicNameSearchKey);
                    }
                  } else {
                    navigate(-1);
                  }
                }}
                isSearchOn={localSearchOn}
                setIsSearchOn={handleSearchToggle}
                background={
                  props.patients?.backgroundColors?.[
                    props.patients?.currentProfile
                  ]
                }
                showSearch={hasValidAccessToken}
                searchResultElementRef={searchResultElementRef}
                incident={props.app?.featureFlags?.incident?.patients}
                incidentOnClick={() => navigate("/incidents")}
              />

              <div className="padding-larger">
                <Shimmer />
              </div>
              <ProfileSwitcherModal patients={props.patients} />
            </>
          }
        />

        <Route
          path="/clinicSearch"
          element={
            <>
              <Header
                displayName={
                  props.patients?.profiles?.[props.patients?.currentProfile]
                    ?.fullName
                }
                title={documentUploadTitle(file.type)}
                loading={false}
                searchKeyword={searchClinic}
                searchPlaceHolder="Search clinic / lab"
                profile-picture-data-cy="CURRENT-PROFILE-IMAGE"
                primary={!isValidArray(src) && !isValidArray(pdfs)}
                onProfilePictureClick={() =>
                  navigate(
                    isAbdmLoggedIn ? "/switchProfile" : "/logout/confirm"
                  )
                }
                userProfilePictureSrc={
                  props.patients?.healthIdData?.[props.patients?.currentProfile]
                    ?.profilePhoto
                    ? `data:image/png;base64, ${
                        props.patients.healthIdData[
                          props.patients?.currentProfile
                        ].profilePhoto
                      }`
                    : null
                }
                notificationsCount={getNotificationCounts(
                  props.patients?.currentProfile
                )}
                hideSupport={true}
                showQr={hasValidAccessToken}
                onQrClick={() => {
                  navigate("/settings/abdmHealthIdQr");
                }}
                backButtonOnClick={() => {
                  if (isValidArray(src) || isValidArray(pdfs)) {
                    setSrc([]);
                    setPdfs([]);
                  } else {
                    navigate(-1);
                  }
                }}
                onSearchUser={(clinicNameSearchKey) => {
                  if (
                    clinicNameSearchKey &&
                    clinicNameSearchKey !== searchClinic &&
                    hasValidAccessToken &&
                    !props.abdm?.loading
                  ) {
                    if (props.app?.featureFlags?.findClinic) {
                      setSearchClinic(clinicNameSearchKey);
                      searchAbdmClinic?.(clinicNameSearchKey);
                    }
                  } else {
                    navigate(-1);
                  }
                }}
                isSearchOn={localSearchOn}
                setIsSearchOn={handleSearchToggle}
                background={
                  props.patients?.backgroundColors?.[
                    props.patients?.currentProfile
                  ]
                }
                showSearch={hasValidAccessToken}
                searchResultElementRef={searchResultElementRef}
                incident={props.app?.featureFlags?.incident?.patients}
                incidentOnClick={() => navigate("/incidents")}
              />
              <div
                style={{
                  height: "calc(100% - 104px)"
                }}
                className="overflow-scroll margin-larger"
              >
                <ClinicSearchResult
                  app={props.app}
                  loading={props.abdm?.loading}
                  searchKey={searchClinic}
                  publicHealthPrograms={
                    props.abdm?.clinics?.search?.publicHealthPrograms
                  }
                  searchResults={
                    isValidObject(props.abdm?.clinics?.search?.results)
                      ? Object.values(props.abdm.clinics.search.results)
                      : []
                  }
                  searchHistory={props.abdm?.clinics?.search?.searchHistory}
                  abdmAccessToken={
                    hasValidAccessToken
                      ? props.patients.accessToken?.[
                          props.patients?.currentProfile
                        ]?.token
                      : null
                  }
                  clinicCardOnClick={(clinicId, type) => {
                    if (
                      !type &&
                      props.abdm?.clinics?.search?.results?.[clinicId]
                    ) {
                      setSearchHistory?.({
                        [clinicId]: {
                          ...props.abdm.clinics.search.results[clinicId],
                          timestamp: Date.now()
                        }
                      });
                    }
                    navigate(`/clinicSearch/${clinicId}`, { replace: true });
                  }}
                  connectOnClick={() => {
                    setAuthModes(null);
                    setTransactionId(null);
                    navigate("/abdm/login");
                  }}
                />
              </div>
            </>
          }
        />

        <Route
          path="/clinicSearch/:clinicId/*"
          element={<ViewSearchedClinicCareContext />}
        />

        <Route path="/incidents" element={<Incidents />} />
        <Route
          path="/patientTimeline/:documentType/:documentId/*"
          element={<ViewDocument />}
        />

        {/* ABDM Routes */}
        <Route path="/abdm/*" element={<Outlet />}>
          <Route path="login/*" element={<ABDMVerify />} />
          <Route path="register/*" element={<ABDMVerify />} />
          <Route path="list/*" element={<ABDMList />} />
          <Route path="create/*" element={<ABDMCreate />} />
          <Route
            path=":abdmRequestType/:abdmRequestId/*"
            element={<ViewRequest />}
          />
        </Route>

        {/* Default Route */}
        <Route
          path="/*"
          element={
            <>
              {/* Always rendered: the cropper overlays it, so a batch in the
                  rearrange grid survives cropping another image. */}
              <div className="inherit-parent-height">
                <Header
                  displayName={
                    props.patients?.profiles?.[props.patients?.currentProfile]
                      ?.fullName
                  }
                  title={documentUploadTitle(file.type)}
                  loading={false}
                  searchKeyword={searchClinic}
                  searchPlaceHolder="Search clinic / lab"
                  profile-picture-data-cy="CURRENT-PROFILE-IMAGE"
                  primary={!isValidArray(src) && !isValidArray(pdfs)}
                  onProfilePictureClick={() =>
                    navigate(
                      isAbdmLoggedIn ? "/switchProfile" : "/logout/confirm"
                    )
                  }
                  userProfilePictureSrc={
                    props.patients?.healthIdData?.[
                      props.patients?.currentProfile
                    ]?.profilePhoto
                      ? `data:image/png;base64, ${
                          props.patients.healthIdData[
                            props.patients?.currentProfile
                          ].profilePhoto
                        }`
                      : null
                  }
                  notificationsCount={getNotificationCounts(
                    props.patients?.currentProfile
                  )}
                  hideSupport={true}
                  showQr={hasValidAccessToken}
                  onQrClick={() => {
                    navigate("/settings/abdmHealthIdQr");
                  }}
                  backButtonOnClick={() => {
                    if (isValidArray(src) || isValidArray(pdfs)) {
                      setSrc([]);
                      setPdfs([]);
                      navigate("/patientTimeline/upload");
                    } else {
                      navigate(-1);
                    }
                  }}
                  onSearchUser={(clinicNameSearchKey) => {
                    if (
                      clinicNameSearchKey &&
                      clinicNameSearchKey !== searchClinic &&
                      hasValidAccessToken &&
                      !props.abdm?.loading
                    ) {
                      if (props.app?.featureFlags?.findClinic) {
                        setSearchClinic(clinicNameSearchKey);
                        searchAbdmClinic?.(clinicNameSearchKey);
                      }
                    } else {
                      navigate(-1);
                    }
                  }}
                  isSearchOn={localSearchOn}
                  setIsSearchOn={handleSearchToggle}
                  background={
                    props.patients?.backgroundColors?.[
                      props.patients?.currentProfile
                    ]
                  }
                  showSearch={hasValidAccessToken}
                  searchResultElementRef={searchResultElementRef}
                  incident={props.app?.featureFlags?.incident?.patients}
                  incidentOnClick={() => navigate("/incidents")}
                />

                <div className="remaining-body-height overflow-x-scroll">
                  <SubscriptionWarning
                    resubscribeClick={() => {
                      healthLockerAuthorization();
                    }}
                  />
                  <Routes>
                    <Route
                      path="/"
                      element={
                        !location.pathname.includes(
                          "/patientTimeline/upload"
                        ) &&
                        props.patients?.loading &&
                        (props.patients.autoApprovalPolicies === null ||
                          props.patients.linkingToken === null ||
                          props.patients.subscription === null ||
                          props.patients.currentProfile === null) ? (
                          <HomePageLoading />
                        ) : (
                          <Outlet />
                        )
                      }
                    >
                      <Route
                        path="/connect"
                        element={
                          <div className="inherit-parent-height padding-larger flex-justify-content-center flex-align-items-center">
                            <ConnectABDM
                              connectOnClick={() => {
                                setAuthModes(null);
                                setTransactionId(null);
                                navigate("/abdm/login");
                              }}
                            />
                          </div>
                        }
                      />

                      <Route
                        path="/locker/subscribe"
                        element={
                          <SubscribeLocker
                            connectOnClick={() => {
                              healthLockerAuthorization();
                            }}
                            connectLoading={props.patients?.loading}
                          />
                        }
                      />

                      <Route
                        path="/locker/consent"
                        element={
                          <PersonalDataConsentForm
                            loading={props.patients?.loading}
                            agreeClick={() => {
                              setConsentToPersonalData(navigate);
                            }}
                          />
                        }
                      />

                      <Route
                        path="/feature-flags-fallback"
                        element={<FeatureFlagsFallback />}
                      />

                      <Route
                        path="/rearrange"
                        element={
                          <div className="inherit-parent-height inherit-parent-width padding-larger">
                            {(isValidArray(pdfs) || isValidArray(src)) && (
                              <ReArrangeFiles
                                key={isValidArray(pdfs) ? "pdf" : "image"}
                                kind={isValidArray(pdfs) ? "pdf" : "image"}
                                items={isValidArray(pdfs) ? pdfs : src}
                                setItems={isValidArray(pdfs) ? setPdfs : setSrc}
                                onAddClick={() =>
                                  documentUploadRef.current?.click()
                                }
                                onUploadClick={() => setShowFileNameModal(true)}
                                uploadButtonText={documentUploadTitle(
                                  file.type
                                )}
                                isLoading={props.documents?.loading}
                              />
                            )}
                          </div>
                        }
                      />

                      <Route
                        path="/patientTimeline/*"
                        element={
                          <Timeline onNewDocumentCreate={onNewDocumentCreate} />
                        }
                      />
                    </Route>
                    <Route path="logout/*" element={<LogoutSection />} />
                  </Routes>
                </div>
              </div>
            </>
          }
        />
      </Routes>
    </div>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  abdm: state.abdm,
  profile: state.profile,
  notifications: state.notifications,
  downloads: state.downloads,
  documents: state.documents,
  patients: state.patients,
  app: state.app
});

export default connect(mapStateToProps)(Home);

function ClinicSearchResult(props) {
  return props.app.featureFlags?.findClinic ? (
    <>
      <ConditionalRender condition={typeof props.abdmAccessToken !== "string"}>
        <div className="inherit-parent-height flex-justify-content-center flex-align-items-center">
          <ConnectABDM connectOnClick={props.connectOnClick} />
        </div>
      </ConditionalRender>

      <ConditionalRender
        condition={
          typeof props.abdmAccessToken === "string" &&
          props.loading === false &&
          props.searchResults?.length > 0
        }
      >
        <div className="font-size-small flex-justify-content-center position-sticky top-0 background-white padding-bottom-small padding-top-small z-index-1">
          HOSPITALS / CLINIC
        </div>

        {props.searchResults?.map(
          (data, index) =>
            (props.publicHealthPrograms
              ? Object.values(props.publicHealthPrograms).some(
                  (healthProgram) =>
                    healthProgram.identifier?.name !== data?.identifier?.name
                )
              : true) && (
              <div key={index}>
                <ClinicProfileCard
                  onClick={() => {
                    props.clinicCardOnClick(data?.identifier?.id);
                  }}
                  clinicName={data?.identifier?.name}
                  locality={data?.city ? data?.city : ""}
                />
              </div>
            )
        )}
      </ConditionalRender>

      <ConditionalRender
        condition={
          typeof props.abdmAccessToken === "string" &&
          props.loading === false &&
          props.searchResults?.length === 0 &&
          props.searchHistory &&
          Object.values(props.searchHistory).length > 0
        }
      >
        <div className="font-size-small flex-justify-content-center">
          SEARCH HISTORY
        </div>
        {props.searchHistory &&
          Object.values(props.searchHistory)
            .sort((first, second) => second.timestamp - first.timestamp)
            .map(
              (data, index) =>
                index < 3 && (
                  <div key={index}>
                    <ClinicProfileCard
                      onClick={() => {
                        props.clinicCardOnClick(
                          data?.identifier?.id,
                          "history"
                        );
                      }}
                      history={true}
                      clinicName={data?.identifier?.name}
                      locality={data?.city ? data?.city : ""}
                    />
                  </div>
                )
            )}
      </ConditionalRender>

      <ConditionalRender
        condition={
          typeof props.abdmAccessToken === "string" && props.loading === false
        }
      >
        <div className="font-size-small flex-justify-content-center font-color-secondary">
          HEALTH PROGRAM
        </div>
        {props.publicHealthPrograms &&
          Object.values(props.publicHealthPrograms).map((data, index) => (
            <div
              key={index}
              onClick={() => {
                props.clinicCardOnClick(data?.identifier?.id, "healthProgram");
              }}
              className="padding-top-large padding-bottom-large flex-justify-content-space-between font-color-secondary"
            >
              <div>{data.identifier?.name}</div>
              <img
                className="clinic-connection-remove-icon-height cursor-pointer"
                src={greaterThanIcon}
                width="auto"
                alt="connection-remove-icon"
              />
            </div>
          ))}
      </ConditionalRender>

      <ConditionalRender
        condition={
          typeof props.abdmAccessToken === "string" && props.loading === true
        }
      >
        {[...Array(20)].map((_e, index) => (
          <div key={index}>
            <ClinicProfileCard
              loading={props.loading}
              clinicName={""}
              locality={""}
            />
          </div>
        ))}
      </ConditionalRender>
    </>
  ) : (
    <FeatureFlagsFallback />
  );
}

const ClinicProfileCard = (props) => {
  return (
    <React.Fragment key={props.clinicName}>
      <div
        className="display-flex margin-vertical-large"
        data-cy={props.clinicName}
      >
        <div
          className="display-flex flex-grow-1 flex-align-items-center font-color-secondary"
          onClick={props.onClick}
        >
          <RoundedProfilePicture
            userType="corporate"
            loading={props.loading}
            size="medium"
            src={props.profilePictureUrl?.[props.clinicName]}
          />
          {props.loading ? (
            <div className="inherit-parent-width flex-direction-column display-flex padding-left-medium flex-justify-content-center">
              <span className="border-radius-default shimmer padding-small width-50-percentage margin-bottom-default" />
              <span className="shimmer padding-small border-radius-default width-20-percentage" />
            </div>
          ) : (
            <div className="flex-grow-1 flex-direction-column display-flex padding-left-medium">
              <span
                className="font-size-medium font-family-gilroy-regular"
                data-cy={props.clinicName}
              >
                {props.clinicName}
              </span>
              <span
                className="font-size-small font-family-gilroy-regular text-transform-capitalize padding-top-small"
                data-cy={props.clinicName}
              >
                {props.locality}
              </span>
            </div>
          )}
          {!props.loading && !props.history && (
            <img
              className="clinic-connection-remove-icon-height cursor-pointer"
              data-cy={`${props.clinicName}-arrowIcon`}
              src={greaterThanIcon}
              width="auto"
              alt="connection-remove-icon"
            />
          )}
          {props.history && (
            <img
              className="clinic-connection-remove-icon-height cursor-pointer"
              data-cy={`${props.clinicName}-arrowIcon`}
              src={historyIcon}
              width="auto"
              alt="history-icon"
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

const SubscribeLocker = (props) => {
  return (
    <section
      data-cy="subscribe-locker"
      className="inherit-parent-height text-align-center inherit-parent-width padding-horizontal-larger display-flex flex-align-items-center flex-direction-column flex-justify-content-center"
    >
      <img
        src={ninto_logo}
        alt="ninto logo"
        draggable={false}
        width="auto"
        height="24"
      />
      <h3 className="padding-vertical-large font-family-gilroy-medium font-size-medium font-color-secondary">
        Ninto health locker
      </h3>

      <div className="font-family-gilroy-regular font-color-secondary font-size-medium line-height-140-percentage">
        Fetch & store your documents such as prescriptions, reports, wellness
        records, receipts, etc. securely
      </div>

      <div className="font-family-gilroy-regular font-color-secondary font-size-small line-height-140-percentage padding-vertical-large">
        By approving, you agree with Ninto's terms of service & privacy
        policies. You can opt out of this any time.
      </div>

      <Button
        boxShadow={false}
        data-cy="CONNECT-NOW-BUTTON"
        className={"width-40-percentage"}
        text="Continue"
        loading={props.connectLoading}
        onClick={props.connectOnClick}
      />
    </section>
  );
};

const HomePageLoading = () => {
  return (
    <section
      className="padding-top-default padding-bottom-large overflow-hidden"
      data-cy="home-page-loading"
    >
      <div className="inherit-parent-width display-flex flex-align-items-center overflow-x-scroll padding-left-default padding-right-default padding-bottom-larger">
        <div className="shimmer padding-right-larger padding-left-larger padding-top-medium padding-bottom-medium margin-right-default  border-radius-default" />
        <div className="shimmer width-150px padding-medium margin-right-default  border-radius-default" />
        <div className="shimmer width-150px padding-medium margin-right-default border-radius-default" />
        <div className="shimmer width-150px padding-medium margin-right-default border-radius-default" />
      </div>
      <div className="display-flex flex-justify-content-space-between margin-left-large margin-right-large padding-bottom-default">
        <div className="shimmer padding-default border-radius-default width-150px" />
        <div className="shimmer border-radius-default padding-right-larger padding-left-larger padding-top-large">
          <div className="padding-left-larger" />
        </div>
      </div>

      {[...Array(5)].map((_data, index) => (
        <div
          key={index}
          className="padding-top-larger padding-left-large padding-right-large border-bottom-1px-e5e5e5"
        >
          <div className="display-flex flex-justify-content-space-between">
            <div className="shimmer  padding-default border-radius-default padding-right-larger padding-left-larger">
              <div className="padding-left-larger padding-right-larger" />
            </div>
            <div className="shimmer  border-radius-default padding-right-larger padding-left-larger padding-top-large">
              <div className="padding-left-larger padding-right-large" />
            </div>
          </div>

          <div className="flex-center-children-vertically padding-top-large  padding-bottom-larger">
            <div className="shimmer padding-large border-radius-50-percentage height-width-16px" />
            <div className="margin-left-default">
              <div className="shimmer  padding-default border-radius-default width-200px" />
              <div className="shimmer margin-top-default padding-small border-radius-default width-150px">
                <div className="padding-smaller" />
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="shimmer position-absolute bottom-15px right-15px  padding-larger border-radius-default height-width-16px" />
      <div className="shimmer position-absolute bottom-75px right-15px  padding-larger border-radius-default height-width-16px" />
    </section>
  );
};

function ProfileCard(props) {
  return (
    <>
      {!props.type && (
        <div
          data-cy={props.dataCy}
          className="inherit-parent-width flex-justify-content-space-between margin-bottom-large border-radius-default cursor-pointer"
          onClick={props.onClick}
        >
          <div className="flex-center-children-vertically">
            <RoundedProfilePicture
              size="medium"
              removeResponsive={true}
              src={props.src}
            />
            <div className="padding-left-large">
              <div className="font-size-large padding-right-default text-capitalize">
                {props.data.name}
              </div>
              <div className="font-size-small">{props.data.healthId}</div>
            </div>
          </div>

          <div className="display-flex">
            <ConditionalRender condition={props.selected === true}>
              <div className="padding-right-large flex-center-children-vertically">
                <TickIcon color="#00A000" />
              </div>
            </ConditionalRender>

            <div
              data-cy={`${props.data.healthId}-setting-icon`}
              onClick={(e) => {
                e.stopPropagation();
                props.onSettingClick?.();
              }}
              className="flex-center-children-vertically"
            >
              <SettingIcon />
            </div>
          </div>
        </div>
      )}

      {props.type === "create" && (
        <div
          data-cy="CREATE-CARD"
          className="flex-justify-content-space-between flex-center-children-vertically cursor-pointer inherit-parent-width"
          onClick={props.onClick}
        >
          <div className="display-flex flex-center-children-vertically">
            <div className="background-color-secondary border-radius-100-percentage height-and-width-44px flex-place-children-page-center">
              <AddIcon />
            </div>
            <div className="font-size-medium padding-left-large">
              {props.text}
            </div>
          </div>
          <div className="flex-center-children-vertically">
            <ArrowIcon />
          </div>
        </div>
      )}
    </>
  );
}

const ProfileSwitcherModal = (props) => {
  const navigate = useNavigate();
  return (
    <Modal
      show={true}
      canIgnore={
        props.patients.currentProfile &&
        typeof props.patients.currentProfile === "string"
      }
      onClose={() => {
        navigate(-1);
      }}
      position="position-fixed bottom-0 left-0 right-0"
      width="inherit-parent-width"
      maxWidth="false"
      height="false"
      background="false"
      boxShadow="false"
      borderRadius="false"
    >
      <div
        className={`${
          isValidObject(props.patients.profiles) &&
          Object.values(props.patients?.profiles).length <= 6
            ? "height-fit-to-content"
            : "height-500-px"
        } inherit-parent-width background-white padding-top-large padding-bottom-large padding-left-larger padding-right-larger font-family-gilroy-regular font-color-secondary`}
        data-cy="patients-switch-modal"
      >
        <div className="position-relative inherit-parent-height inherit-parent-width">
          <div className="padding-bottom-large text-align-center font-size-small">
            {typeof props.patients.currentProfile === "string"
              ? "SWITCH PROFILE"
              : "CHOOSE A PROFILE TO LOGIN"}
          </div>

          <div
            className={`${
              isValidObject(props.patients.profiles) &&
              Object.values(props.patients?.profiles).length <= 6
                ? "height-fit-to-content"
                : "height-398-px"
            } overflow-scroll`}
          >
            {isValidObject(props.patients.profiles) &&
              Object.values(props.patients?.profiles)
                .sort((a, b) => {
                  if (a.documentId === props.patients.currentProfile) return -1;
                  if (b.documentId === props.patients.currentProfile) return 1;
                  return a.healthId?.localeCompare(b.healthId);
                })
                .map((data, index) => (
                  <React.Fragment key={index}>
                    <ProfileCard
                      dataCy={`profile-${data.healthId}`}
                      src={
                        props.patients.healthIdData?.[data.documentId]
                          ? props.patients.healthIdData?.[data.documentId]
                              ?.profilePhoto
                            ? `data:image/png;base64,${
                                props.patients.healthIdData?.[data.documentId]
                                  ?.profilePhoto
                              }`
                            : null
                          : null
                      }
                      selected={
                        props.patients.currentProfile === data.documentId
                      }
                      key={index}
                      data={{
                        name: data?.name,
                        healthId: data?.healthId
                      }}
                      onClick={() => {
                        navigate("/");
                        switchPatientProfile(data.documentId);
                      }}
                      onSettingClick={() => {
                        switchPatientProfile(data.documentId);
                        navigate("/settings");
                      }}
                    />
                  </React.Fragment>
                ))}
          </div>
          <div
            className={`${
              isValidObject(props.patients.profiles) &&
              Object.values(props.patients?.profiles).length <= 6
                ? ""
                : "position-absolute bottom-0"
            } inherit-parent-width  padding-top-default background-color-white`}
          >
            <ProfileCard
              type="create"
              text="Add ABHA address"
              onClick={() => {
                if (
                  props.patients.accessToken?.[props.patients.currentProfile]
                    ?.token
                ) {
                  navigate("/abdm/register");
                } else {
                  navigate("/abdm/login");
                }
                setTransactionId(null);
                setAuthModes(null);
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

const Shimmer = () => {
  return (
    <article>
      <div className="inherit-parent-width">
        {[...Array(4).keys()].map((index) => (
          <div
            className="display-flex flex-direction-column margin-bottom-larger"
            key={index}
          >
            <div className="shimmer inherit-parent-width padding-large" />
            <div className="shimmer width-50-percentage padding-medium margin-top-default" />
          </div>
        ))}
      </div>
    </article>
  );
};

const LogoutSection = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="padding-larger">
        <Shimmer />
      </div>
      <Modal
        show={true}
        canIgnore={true}
        onClose={() => navigate("/")}
        width="inherit-parent-width"
        position="position-fixed bottom-0 left-0 right-0"
        maxWidth="max-width-630px"
        background="false"
        boxShadow="false"
        borderRadius="false"
        height="height-fit-to-content"
      >
        <LogoutCard onclick={() => navigate("confirm")} />
        <Routes>
          <Route
            path="confirm"
            element={
              <LogoutModal
                logout={() => {
                  navigate("/");
                  logout();
                }}
                onClose={() => navigate("/")}
              />
            }
          />
        </Routes>
      </Modal>
    </>
  );
};
